// src/features/locker-types/types/index.ts

import { RaRecord } from 'react-admin';

export interface LockerType extends RaRecord {
  id: string;
  name: string;
  description?: string;
  hotelId: string;
  hotel?: {
      id: string;
      name: string;
  };
  createdAt: string;
}

export interface LockerTypeFormData {
  name: string;
  description?: string;
  hotelId: string;
}

export interface LockerTypeValidationErrors {
  name?: string;
  description?: string;
  hotelId?: string;
}

export const prepareLockerTypeForAPI = (data: LockerTypeFormData): any => ({
  name: data.name,
  description: data.description || null,
  hotelId: data.hotelId,
});